module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Down-2-5ec16f11e809e594832eb76f42c1af72.svg";